import React from 'react';
import ReactDOM from 'react-dom/client';
import { App } from './App';
import { configureAmplify } from './config/amplify';
import './index.css';

configureAmplify();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
